import React, { Component } from "react";
import { Card } from "react-bootstrap";
import logo from "../../media/logo.png";
import moment from "moment";
import settings from "../../settings";

class FusePanel extends Component {
  state = {};

  handleClick = (e) => {};

  render() {
    const { current } = this.state;
    return (
      <Card>
        <Card.Header
          className="bg-primary text-light"
          onClick={(e) => {
            this.handleClick(e);
          }}
        >
          <strong>{this.props.title}</strong>
        </Card.Header>
        <Card.Body hidden={this.state.isCollapsed}>
          {this.props.children}
        </Card.Body>
      </Card>
    );
  }
}

export default FusePanel;
